import React from "react";
import { motion } from "framer-motion";
import "./Hero.css";
import banner from "../Images/header_Img.jpg"; // fallback background
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <header className="hero" style={{ backgroundImage: `url(${banner})` }}>
      <div className="overlay" />
      <div className="container hero-content">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="hero-inner"
        >
          <h1>Find Your Next Home</h1>
          <p className="lead">The easiest way to find and rent your perfect property.</p>

          <motion.form
            className="hero-box"
            initial={{ scale: 0.98 }}
            whileHover={{ scale: 1.01 }}
            transition={{ duration: 0.3 }}
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="search-box">
              <input aria-label="search" type="text" placeholder="Enter city, neighborhood..." />
             
              <select aria-label="budget">
                <option>Budget</option>
                 <option>10000-20000</option>
                  <option>5000-10000</option>
                   <option>500-5000</option>
              </select>
              <button className="search-btn btn" type="submit" onClick={() => navigate('/search-results')}>
                Search
              </button>
            </div>
          </motion.form>
        </motion.div>
      </div>
    </header>
  );
};

export default Hero;
